import { ThemeSchema, type Theme } from '@betrayal/shared';
import fantasy from '../../../themes/fantasy.json';
import mythology from '../../../themes/mythology.json';
import europe from '../../../themes/europe.json';
import wildwest from '../../../themes/wildwest.json';
import babylon from '../../../themes/babylon.json';
import japan from '../../../themes/japan.json';

export const THEMES: Theme[] = [fantasy, mythology, europe, wildwest, babylon, japan].map((t) =>
  ThemeSchema.parse(t),
);

export function getTheme(id: string): Theme {
  return THEMES.find((t) => t.id === id) ?? THEMES[0]!;
}
